/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const UpdateEmailContentTypeDto = {
    Boxes: 'BOXES',
    CakeInstallationAgencies: 'CAKE_INSTALLATION_AGENCIES',
    CakeInstallationCompanies: 'CAKE_INSTALLATION_COMPANIES',
    Christmas2026: 'CHRISTMAS_2026',
    ChristmasOffer: 'CHRISTMAS_OFFER',
    Custom: 'CUSTOM',
    DecisionQuestionRequest: 'DECISION_QUESTION_REQUEST',
    Easter2026: 'EASTER_2026',
    FatThursday: 'FAT_THURSDAY',
    ForumEventCompanies: 'FORUM_EVENT_COMPANIES',
    General: 'GENERAL',
    GrazingTable: 'GRAZING_TABLE',
    NewSeason2026: 'NEW_SEASON_2026',
    OpenDayFoksal: 'OPEN_DAY_FOKSAL',
    OpinionRequest: 'OPINION_REQUEST',
    PostEventFollowUp: 'POST_EVENT_FOLLOW_UP',
    ResponseAsSoonAsPossible: 'RESPONSE_AS_SOON_AS_POSSIBLE',
    ResponseAsSoonAsPossibleWithRequestVerification: 'RESPONSE_AS_SOON_AS_POSSIBLE_WITH_REQUEST_VERIFICATION',
    SendingOffer: 'SENDING_OFFER',
    SixFloorTheatre: 'SIX_FLOOR_THEATRE',
    SixFloorTheatreOpenDay: 'SIX_FLOOR_THEATRE_OPEN_DAY',
} as const;

export type UpdateEmailContentTypeDto = typeof UpdateEmailContentTypeDto[keyof typeof UpdateEmailContentTypeDto];



